import React from "react";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import Errormsg from "@frameworks/web/components/generic/errorMsg";
import { Accordion } from "react-bootstrap";
var RecentlySearchedBlock = function (props) {
    var device = DeviceContext();
    // React.useEffect(() => {
    //   if (props.stockCount > 0 && clicked) {
    //     props.onClearAll();
    //     setClicked(false);
    //   } else {
    //     props.setEdit(false);
    //   }
    // }, [props.stockCount]);
    return (React.createElement("div", { className: "Recently-search-block pdt-20 ".concat((device === null || device === void 0 ? void 0 : device.isDesktop) ? "" : "pdlr-15") },
        React.createElement("div", { className: "flexJustifySpaceBetween" },
            React.createElement("div", { className: "DMSanN_16_400 txt_secondary-gray lh-140 pdb-9" },
                "Recently Searched (",
                props.stockCount ? props.stockCount : "0",
                ")"),
            React.createElement("div", null, props.editMode ? (React.createElement("div", { className: "d-flex  justify-content-end gap-10 align-items-center" },
                React.createElement(EdButton, { onClick: function () { return props.onClearAll(); }, btnTyp: "midnight-blue-underline", value: "Clear All", className: "small-edbutton-search" }),
                React.createElement(EdButton, { onClick: function () { return props.setEdit(false); }, btnTyp: "midnight-blue-underline", value: "Done", className: "small-edbutton-search" }))) : (React.createElement("div", null, (props === null || props === void 0 ? void 0 : props.isEmpty) !== true ? (React.createElement("div", { onClick: function () { return props.setEdit(true); } },
                React.createElement("i", { className: "edel-icon-edit hand_cursor" }))) : (React.createElement("i", { className: "edel-icon-edit" })))))),
        props.isEmpty ? (React.createElement("div", { className: "Trending-search-block ".concat((device === null || device === void 0 ? void 0 : device.isDesktop) ? "" : "pdlr-15") },
            React.createElement(Accordion, { defaultActiveKey: "0", flush: true },
                React.createElement(Accordion.Item, { eventKey: "0" },
                    React.createElement(Accordion.Body, null,
                        React.createElement(Errormsg, { icon: "", msg: "No search history", showIcon: false })))))) : (React.createElement("div", { className: "border-monochrome-grey" }, props.content))));
};
export default RecentlySearchedBlock;
